import React, { FC } from 'react';
import { Contact } from '../../interfaces/Contact';
import { StyledServiceCenter } from './ServiceCenter.styles';

export interface ServiceCenterProps {
  contact: Contact;
}

const ServiceCenter: FC<ServiceCenterProps> = ({ contact }) => (
  contact && contact.serviceCenter ? <StyledServiceCenter>{contact.serviceCenter}</StyledServiceCenter> : null);

export default ServiceCenter;
